export function isHidden(elem: HTMLElement): boolean {
	const checkIsHidden = (element: HTMLElement): boolean => {
		if ('none' == element.style.display || 'hidden' == element.style.visibility) {
			return true;
		}

		const cs = getComputedStyle(element);
		return 'none' === cs.display || 'hidden' === cs.visibility;
	};

	return checkIsHidden(elem) || (!!elem.parentElement && checkIsHidden(elem.parentElement));
}
